import React from "react";
import {Flex} from "components/common_style/flex";
import styled from 'styled-components';
import ReactSlider from "react-slider";
import {Colors} from "components/constants";
import {Button} from "components/common_style/button";

const StyledSlider = styled(ReactSlider)`
    width: 100%;
    height: 48px;
    background: transparent;
    `;

const StyledThumb = styled.div`
    height: 48px;
    width: 48px;
    background-color: ${Colors.button};
    box-shadow: 0 0 13px 0 rgba(255,100,37,0.54);
    border-radius: 50%;
    cursor: grab;
    outline: none;
`;

const SliderContainer = styled.div`
  position: relative;
  width: 576px;
  height: 48px;
`;

const SliderBg = styled.div`
    position: absolute;
    background-color: ${Colors.primaryOpaque};
    clip-path: polygon(0 50%, 100% 0, 100% 100%);
    top: 0;
    bottom: 0;
    left: 0;
    right: 20px;
`;


const Thumb = (props, state) => <StyledThumb {...props}/>;

const StyledTrack = styled.div`
    top: 0;
    bottom: 0; 
    border-radius: 999px;
`;

const ColorPatch = styled.div`
background-color: ${props => props.color};
width: 49px;
height: 49px;
border-radius: 50px;
margin: 5px;
border: 1px solid #FF6425;
cursor: pointer;
box-shadow: 0 0 3px 0 rgba(255,100,37,0.74);
`;

const Track = (props, state) => <StyledTrack {...props} index={state.index}/>;

const tColors = ['#FFFFFF', '#000000', '#0097F8', '#50C53B', '#FFCB41', '#FF8800', '#FF3351', '#E4006B', '#B200C1'];

function TextToolsView(props) {
    return (
        <Flex wmax hmax column style={{backgdroundColor: 'red'}}>
            <Flex wmax hmax row hAlign={'center'} vAlign={'center'}>
                {tColors.map((c => <ColorPatch key={'color-'+c} color={c} onClick={() => props.onColoChange(c)}/>))}
            </Flex>
            <Flex wmax hmax row hAlign={'center'} vAlign={'center'}>
                <SliderContainer>
                    <SliderBg/>
                    <Flex wmax hAlign={'center'} vAlign={'center'}>
                        <StyledSlider
                            onChange={(val) => props.onSizeChange(val / 10.0)}
                            value={[!!props.styles ? Math.round(props.styles.fontSize * 10) : 20]}
                            max={50}
                            min={10}
                            renderTrack={Track}
                            renderThumb={Thumb}/>
                    </Flex>
                </SliderContainer>
                <div style={{width: '10%'}}/>
                <Button onClick={props.onDone}>DONE</Button>
            </Flex>
        </Flex>
    );
}

export default TextToolsView;